import { ArrowShortDownIcon } from '@fourthwall/icons'
import React from 'react'
import { PriceString } from '../../../functional/PriceString'
import { Icon } from '../../Icon'
import { OrderSummaryTooltip } from '../OrderSummaryTooltip/OrderSummaryTooltip'
import * as S from './styled'
import type { SummaryRowProps } from './types'
import { isPrice } from './utils'

export const SummaryRow = ({
  label,
  value,
  suggestion,
  tooltipContent,
  testId,
  bold = false,
  highlighted = false,
}: SummaryRowProps) => {
  const renderValue = () => {
    if (isPrice(value)) {
      return (
        <div>
          <PriceString value={value.value} currency={value.currency} />
        </div>
      )
    }

    return <div>{value}</div>
  }

  const renderContent = () => {
    if (tooltipContent) {
      return (
        <>
          <OrderSummaryTooltip content={tooltipContent}>
            <S.LabelWithIcon>
              {label}
              <S.IconContainer>
                <Icon component={ArrowShortDownIcon} height={12} />
              </S.IconContainer>
            </S.LabelWithIcon>
          </OrderSummaryTooltip>
          {renderValue()}
        </>
      )
    }

    return (
      <>
        <S.Label>{label}</S.Label>
        {renderValue()}
      </>
    )
  }

  return (
    <S.Container>
      <S.Main $bold={bold} $highlighted={highlighted} data-testid={testId}>
        {renderContent()}
      </S.Main>
      {suggestion && <S.Suggestion>{suggestion}</S.Suggestion>}
    </S.Container>
  )
}
